import React, { useState } from 'react'
import { Box, Button, Tooltip, Typography } from '@material-ui/core'
import { Form, Formik } from 'formik'
import { AppButton, UploadFile } from '../../Components'
import { programService } from '../../Services'
import { SUCCESS } from '../../utils/messageTypes'
import _ from 'lodash'
import { useStyles } from './style'
import programDetailsCsvFile from '../../Assets/Images/programDetailsCsvFile.svg'
import download from '../../Assets/Images/download.svg'
import DownloadFile from '../../utils/downloadFile'

const DashboardWidgets = (props) => {
  const classes = useStyles()
  const { setOpen, setMessage, setMessageType, setLoading, errorCb } = props

  const downloadWidgetsTemplate = () => {
    setLoading(true)
    programService.downloadWidgetsCSVTemplate(props.accountId)
      .then(templateData => {
        DownloadFile(templateData)
        setOpen(true)
        setMessage('Template downloaded successfully')
        setMessageType(SUCCESS)
        setLoading(false)
      })
      .catch(error => {
        errorCb(error)
      })
  }

  const downloadRecentlyUploadedFile = () => {
    setLoading(true)
    programService.downloadRecenltyUploadedWidgetsCSV(props.accountId, props.programId)
      .then(templateData => {
        DownloadFile(templateData)
        setOpen(true)
        setMessage('File downloaded successfully')
        setMessageType(SUCCESS)
        setLoading(false)
      })
      .catch(error => {
        errorCb(error)
      })
  }

  return (
    <>
      <Box className={classes.enrollmentConfigurationHeader}>DASHBOARD WIDGETS (ENHO App)</Box>
      <Box style={{ color: '#545455' }}>Widgets will be visible in <b>ENHO App</b> :</Box>
      <Formik
        initialValues={{
          enrollmentConfiguration: null,
        }}
        onSubmit={(data, { resetForm }) => {
          if (_.get(data, 'widgetsFile') !== null) {
            setLoading(true)
            programService.uploadWidgetsFile(props.accountId, props.programId, _.get(data, 'widgetsFile', ''))
              .then((data) => {
                setLoading(false)
                setOpen(true)
                setMessage("Dashboard widgets updated successfully")
                setMessageType(SUCCESS)
                document.getElementById('dashboardWidgetFile').value = null
                resetForm()
              })
              .catch((err) => {
                errorCb(err)
              })
          }
        }}>
        {(formik) => (
          <Form>
            <Box className={classes.fileUploadWrapper}>
              <Box className={classes.fileUploadContent}>
                <Typography className={classes.fileUploadLabel}> <img src={programDetailsCsvFile} className={classes.icons} alt="" style={{ marginRight: '10px' }} /> Dashboard Widgets CSV File</Typography>
                <Box display="flex" flexDirection="column" alignItems='flex-end'>
                  <UploadFile
                    isCSV={true}
                    onValueChange={(file) => {
                      formik.setFieldValue('widgetsFile', file)
                    }}
                    uploadId='dashboardWidgetFile'
                  ></UploadFile>
                  <Box className={classes.link} display="flex" alignItems='center' onClick={downloadWidgetsTemplate}>
                    <Box mr={1} display='flex'>
                      <img src={download} alt="" height={15} />
                    </Box>
                    <Box>Download template</Box>
                  </Box>
                  <Box className={classes.link} display="flex" alignItems='center' onClick={downloadRecentlyUploadedFile}>
                    <Box mr={1} display='flex'>
                      <img src={download} alt="" height={15} />
                    </Box>
                    <Box>Download recently uploaded file</Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box className={classes.saveButtonWrapper} flexWrap="wrap">
              <AppButton text='SAVE' minHeight='0px' className={`${classes.saveButton} ${formik.dirty ? '' : classes.disable} `} type="submit" />
            </Box>
          </Form>)}
      </Formik>
    </>
  )
}

export default DashboardWidgets